import React, {useEffect, useMemo} from 'react';
import {Mesh} from 'three';
import {useGLTF} from '@react-three/drei';
import type {MeshType} from 'api/generated';

interface IModelGLB {
  mesh: MeshType;
  onLoad?: () => void;
}

const ModelGLB = ({mesh, onLoad}: IModelGLB) => {
  const glb = useGLTF(mesh.fileUrl!);
  const object = useMemo(() => glb.scene.clone(), [glb]);

  useEffect(() => {
    object.traverse(o => {
      if ((o as Mesh).isMesh) {
        o.castShadow = true;
      }
    });
    onLoad?.();
  }, [object]);

  return <primitive object={object} />;
};

export default React.memo(ModelGLB);
